import { render, staticRenderFns } from "./UserSelects.vue?vue&type=template&id=6f712fac&"
import script from "./UserSelects.vue?vue&type=script&lang=js&"
export * from "./UserSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports